// Backstage (admin) endpoints.

import { z } from 'zod';
import { backstageStatsSchema, backstageUserSchema, backstageHouseholdSchema } from './schema';
import { apiFetch } from '@/lib/http';
import { nullableArray } from '@/lib/schemas/primitives';

export async function fetchBackstageAccess(): Promise<{ hasAccess: boolean }> {
  return apiFetch('/backstage/access', { schema: z.object({ hasAccess: z.boolean() }) });
}

export async function fetchBackstageStats() {
  return apiFetch('/backstage/stats', { schema: backstageStatsSchema });
}

export async function fetchBackstageUsers() {
  return apiFetch('/backstage/users', { schema: nullableArray(backstageUserSchema) });
}

export async function fetchBackstageHouseholds() {
  return apiFetch('/backstage/households', { schema: nullableArray(backstageHouseholdSchema) });
}
